import { LoadingsState } from './types';

// The initial state of the App
const initialState = {};

function loadingReducer(
    state: LoadingsState = initialState,
    action: { type: string }
): LoadingsState {
    const { type } = action;
    const matches = /(.*)_(LOAD)_(REQUESTED|SUCCEEDED|FAILED|CANCELED)/.exec(
        type
    );

    // not a *_REQUEST / *_SUCCEEDED /  *_FAILURE actions, so we ignore them
    if (!matches) return state;

    const [, requestName, requestType, requestState] = matches;
    return {
        ...state,
        // Store whether a request is happening at the moment or not
        [`${requestName}_${requestType}`]: requestState === 'REQUESTED'
    };
}

export default loadingReducer;
